// extracted by mini-css-extract-plugin
export default {"sidedrawerLeft":"SideDrawer_sidedrawerLeft__y4JWT","open":"SideDrawer_open__S4440","sidedrawerRight":"SideDrawer_sidedrawerRight__zfwRr","backdrop":"SideDrawer_backdrop__mWIuA"};